<template>
  <figure>
    <router-link
      :to="{
        name: `book_detail`,
        params: { id: book.bookCode }
      }"
      class="book_link"
    >
      <img :src="book.thumbUrl" :alt="book.bookNm" />
    </router-link>
  </figure>
</template>
<script>
export default {
  name: 'BaseEbookOnly',

  props: {
    book: {
      type: Object,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
figure {
  width: 230px !important;
  height: auto;
  img {
    object-fit: cover;
    max-height: 330px;
    width: 100%;
    aspect-ratio: auto 1 / 1.29;
    border-radius: 10px;
    box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.2);
  }
}
.swiper-slide {
  transform: scale(0.75);
}
.swiper-slide-active {
  transform: scale(1);
}
.book_link {
  display: block;
}
@media (max-width: 1024px) {
  figure {
    width: 184px !important;
  }
}
@media (max-width: 768px) {
  figure {
    width: 147px !important;
  }
}
@media (max-width: 480px) {
  figcaption {
    b {
      font-size: 13px;
      line-height: 16px;
      margin-bottom: 3px;
    }
    span {
      font-size: 9px;
    }
  }
}
</style>
